import script from "./TressVideoPlayer2.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressVideoPlayer2.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__